import {
    SET_ENTRETIENS_LOADING,
    SET_ENTRETIENS_ERROR,
    FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS,
    FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL,
    CREATE_ENTRETIEN_FAIL,
    UPDATE_ENTRETIEN_FAIL,
    SEND_INTERVIEW_CALENDAR_FAIL,
    SEND_INTERVIEW_CALENDAR_SUCCESS,
    UPDATE_ENTRETIEN_SUCCESS,
} from "../actions/entretiensActions";

const initialState = {
    loading: false,
    error: null,
    entretiensByCandidature: {},
    calendarResult: null,
};

export default function entretiensReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ENTRETIENS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };

        case SET_ENTRETIENS_ERROR:
            return {
                ...state,
                error: action.payload,
            };

        case FETCH_ENTRETIENS_BY_CANDIDATURE_SUCCESS:
            return {
                ...state,
                error: null,
                entretiensByCandidature: {
                    ...state.entretiensByCandidature,
                    [action.payload.candidatureId]: action.payload.data || [],
                },
            };

        case SEND_INTERVIEW_CALENDAR_SUCCESS:
        case UPDATE_ENTRETIEN_SUCCESS:
            return {
                ...state,
                error: null,
                calendarResult: action.type === SEND_INTERVIEW_CALENDAR_SUCCESS ? action.payload : state.calendarResult,
            };

        case FETCH_ENTRETIENS_BY_CANDIDATURE_FAIL:
        case CREATE_ENTRETIEN_FAIL:
        case UPDATE_ENTRETIEN_FAIL:
        case SEND_INTERVIEW_CALENDAR_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
}
